import { FormattedMessage } from 'react-intl';
import { FC } from 'react';

export const ExaminationStatusLabel: FC<{ status: String }> = ({ status }) => (
  <FormattedMessage id={`examination.status.${status}`} />
);
